import { Search } from "lucide-react";
import React, { useState } from "react";

const FormInputStyle5 = ({
  isValid,
  isSearchIconReq,
  value,
  onChange,
  label,
  errorMessage,
  tick = false,
  disabled = false,
  labelClassName,
  className = "",
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const showFloatingLabel = isFocused || value;

  return (
    <div
      style={{
        position: "relative",
        marginBottom: "1rem",
        width: "330px",
        marginLeft: "auto",
        marginRight: "auto",
      }}
      className={className} // Allow manual width & other styles
    >
      <input
        {...props}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={(e) => {
          setIsFocused(false);
          if (props.onBlur) props.onBlur(e);
        }}
        className={`font-atkinson w-full`} // Takes full parent width
        disabled={disabled}
        style={{
          height: "65px",
          borderRadius: "15px",
          border: isValid ? "1px solid #B3B3B3" : "1px solid red",
          padding: "20px 40px 8px 12px",
          fontSize: "16px",
          outline: "none",
          backgroundColor: disabled ? "#F5F5F5" : "white",
          color: disabled ? "#A0A0A0" : "inherit",
          cursor: disabled ? "not-allowed" : "text",
        }}
      />
      <label
        htmlFor={label}
        className={labelClassName}
        style={{
          position: "absolute",
          left: "12px",
          top: showFloatingLabel ? "6px" : "18px",
          fontFamily:
            "'SF Pro','SF Pro Display',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
          fontWeight: 400,
          fontSize: "12px",
          color: isValid ? "#B3B3B3" : "red",
          backgroundColor: disabled ? "#F5F5F5" : "white",
          transition: "all 0.2s ease-in-out",
          pointerEvents: "none",
        }}
      >
        {label || "Label"}
      </label>

      {/* Show search icon in tick position */}
      {isSearchIconReq && (
        <Search
          size={18}
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            color: "#A0A0A0",
            cursor: "pointer",
          }}
        />
      )}

      {/* Show tick only if not showing search icon */}
      {tick && isValid && !disabled && !isSearchIconReq && (
        <img
          src="/assets/img/lightGreenTick.svg"
          alt="tick"
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            height: "20px",
            width: "20px",
          }}
        />
      )}

      {!isValid && !disabled && (
        <div style={{ color: "red", fontSize: "12px", marginTop: "6px" }}>
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default FormInputStyle5;
